import { SearchFilterTag } from '@/components';
import type { ProjectSearchFormType } from '@/features/search/_models/projects-search';
import { FundSheetTypeLabelModifier } from '@/utils/enum';
import { type FC, useMemo } from 'react';
import { useFormContext, useWatch } from 'react-hook-form';

export const FundSheetTypeTag: FC = () => {
  const { control } = useFormContext<ProjectSearchFormType>();
  const fundSheetType = useWatch({ control, name: 'fundSheetType' });
  const sheetType = useWatch({ control, name: 'sheetType' });

  const value = useMemo(() => {
    if (!fundSheetType) {
      return null;
    }
    return FundSheetTypeLabelModifier[fundSheetType];
  }, [fundSheetType]);

  if (!value || sheetType !== 'KS') {
    return null;
  }

  return <SearchFilterTag label={value} />;
};
